export default __webpack_public_path__ + "assets/models/648eff52938ffd580543be89393bb789.glb";